import styled from "styled-components";

export const StyledSignupPreview = styled.div`
h4{
    margin-bottom:0;
}
p{
    padding-bottom: 16px;
}
`;